<!--
 * @Author: M.D.
 * @Date: 2019-12-31 13:42:36
 * @LastEditors  : M.D.
 * @Description:
 * @Remarks:
 -->
<template>
  <div class="product-layout-w">
    <el-row :gutter="20">
      <el-col :span="20" :offset="2">
        <keep-alive>
          <router-view
            :key="$route.fullPath"
            @openCompDialog="openCompDialog"
            @openPay="openPay"
            @openLoginDialog="openLoginDialog"
          >
          </router-view>
        </keep-alive>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  props: {},
  data() {
    return {}
  },
  computed: {},
  created() {},
  mounted() {},
  activated() {},
  deactivated() {},
  watch: {},
  methods: {
    openLoginDialog() {
      this.$emit('openLoginDialog')
    },
    openCompDialog() {
      this.$emit('openCompDialog')
    },
    openPay() {
      this.$emit('openPay')
    },
  },
  components: {},
}
</script>

<style lang="stylus">
.product-layout-w
  padding 20px 0
</style>
